






import Vue from 'vue';
import Betaalverzoek from './components/Betaalverzoek.vue';
import axios from '@/axios';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

Vue.prototype.$http = axios;

export default Vue.extend({
    props: {
        tranction_url: {
            type: String,
            default: process.env.VUE_APP_API_URL + 'wp-json/dw-suite/v1/transaction'
        },
        dw_organization_id: {
            type: String,
            default: ''
        },
    },
    components: {
        Betaalverzoek
    }
});
